<section class="relative w-full overflow-hidden py-16 md:py-24" [appScrollSection]="data?.anker">
  <!-- Hintergrundbild -->
  <div
    class="absolute inset-0 -z-10"
    *ngIf="data?.backgroundImage?.fields?.file?.url as bgUrl"
  >
    <img [src]="bgUrl" class="w-full h-full object-cover" alt="" />
    <div class="absolute inset-0 bg-white/60"></div>
  </div>

  <div class="relative max-w-6xl mx-auto px-6">
    <!-- Quote-Sektion -->
    <div class="relative mt-10">
      <!-- dekoratives " an der Ecke (hinter der Border) -->
      <div class="absolute -top-20 -left-8 sm:-top-14 md:left-8 lg:left-14 z-0 select-none pointer-events-none">
        <img
          src="assets/05_Anfuehrungszeichen.png"
          class="w-32 md:w-40"
          alt="Zitatzeichen"
        />
      </div>
      <!-- Quote-Box -->
      <div
        class="relative z-10 border-2 border-black px-6 md:px-12 py-8 md:py-10 align-center text-black max-w-3xl mx-auto"
      >
        <div
          class="quote-copy text-base sm:text-lg md:text-xl leading-relaxed font-primary"
          [innerHTML]="documentToHtmlString(data?.quoteText)"
        ></div>

        <div class="mt-4 text-sm md:text-base font-primary italic text-right">
          {{ data?.quoteAuthor }}
        </div>
      </div>
    </div>

    <!-- Untere Headline -->
    <div class="mt-12 md:mt-16 text-center text-black font-primary">
      <div
        *ngIf="data?.bottomText"
        class="text-xl uppercase"
        [innerHTML]="documentToHtmlString(data?.bottomText)"
      ></div>
    </div>
  </div>
</section>
